import React from 'react';
import Image from 'next/image';
import informationNext from '../../svgs/information_icon.svg';
import { NextImageProps } from '../NextImageProps';

export function InformationNext({ className, width, height, alt }: NextImageProps) {
  return (
    <Image
      width={width}
      height={height}
      className={className}
      src={informationNext}
      alt={alt ?? 'Information'}
    />
  );
}
